class Tabs extends HTMLElement {
    constructor() {
        super();
        
        this.tabs = this.querySelectorAll("li");
        this.tabPanels = document.querySelectorAll(".tab-list ~ .js-tab-panel");
        this.activeTab = this.querySelector("li.active") || this.querySelector(".tab-list > li:first-child");
    }

    connectedCallback() {
        this.setup();
    }

    setup() {
        window.addEventListener("DOMContentLoaded", (event) => {
            let activeTabId = this.activeTab?.id;
            const hash = window.location.hash.slice(1)
            if(hash && document.getElementById(hash)){
                activeTabId =  hash;
                this.activeTab = document.getElementById(activeTabId);
            }else{
                // window.location.hash = activeTabId;
                
            }
            this.toggleActive(this.activeTab);
            
            this.tabs.forEach((tab) => {
                const id = tab.id;
                const herf = tab.herf;
                const a = document.createElement("a");
                
                if(!herf) a.addEventListener("click", this.handleTab.bind(this));

                a.href = herf ? herf : `#${id}`;

                // a.appendChild(document.createTextNode(tab.textContent));
                a.innerHTML = tab.innerHTML;
                tab.innerHTML = "";
                tab.appendChild(a);
            });
        });
    }

    toggleActive(selectedTab){
        this.tabs.forEach((t)=> { t.classList.remove("active") });
        this.tabPanels.forEach((panel) => {
            if (panel.dataset.value !== selectedTab.id) {
                panel.setAttribute("hidden", true);
            }else{
                panel.removeAttribute("hidden");
            }
        });
        selectedTab.classList.add("active");
        this.activeTab = selectedTab;
      
    }

    handleTab(event) { 
        let selectedTab = event.target.closest('li');
        window.location.replace(window.location.href.split('?')[0] +'#' + selectedTab.id)
        this.toggleActive(selectedTab);
    }
}

customElements.define("tab-list", Tabs);


var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

class MobileTabs extends HTMLElement {
    constructor() {
        super();
        this.buttons = this.querySelectorAll(".tab-list-mobile button");
        this.tabPanels = document.querySelectorAll(".tab-list ~ .js-tab-panel");
        this.activeButton = this.querySelector(".tab-list-mobile button.active") || this.querySelector(".tab-list-mobile button:first-child");
    }

    connectedCallback() {
        this.setup();
    }

    setup() {
        this.initializeActiveButton();

        this.buttons.forEach((button) => {
            button.addEventListener("click", this.handleButtonClick.bind(this));
        });
    }

    initializeActiveButton() {
        const hash = window.location.hash.slice(1);
        const hashButton = this.querySelector(`.tab-list-mobile button[id="${hash}"]`);
        this.toggleActive(hashButton || this.activeButton);
    }

    toggleActive(selectedButton) {
        this.buttons.forEach((b) => {
            b.classList.remove("active");
            b.style.backgroundColor = "";
        });

        this.tabPanels.forEach((panel) => {
            if (panel.dataset.value !== selectedButton.id) {
                panel.setAttribute("hidden", true);
            } else {
                panel.removeAttribute("hidden");
            }
        });
        selectedButton.classList.add("active");
        selectedButton.style.backgroundColor = "";
        this.activeButton = selectedButton;
    }

    handleButtonClick(event) {
        let selectedButton = event.currentTarget;
        window.location.replace(window.location.href.split('?')[0] +'#' + selectedButton.id)
        this.toggleActive(selectedButton);
    }

    toggleAccordion(element) {
        var icon = document.getElementById("icon");
        var content = document.getElementById("content");
      
        if (content.style.display === "none" || content.style.display === "") {
          content.style.display = "block";
          icon.innerHTML = "X";
          element.classList.add("rotate");
        } else {
          content.style.display = "none";
          icon.innerHTML = "+";
          element.classList.remove("rotate");
        }
   }
}
customElements.define("button-list", MobileTabs);


  

